import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

export interface PhoneResult {
  normalized?: string
  error?: 'required' | 'prefix' | 'invalid'
}

export function validatePhone(input: string): PhoneResult {
  const value = input.trim()
  if (value === '') return { error: 'required' }
  if (!value.startsWith('+') && !value.startsWith('00')) return { error: 'prefix' }

  const candidate = value.replace(/[ \u00a0\u202f-]/g, '').replace(/^00/, '+')
  if (!/^\+[0-9]+$/.test(candidate)) return { error: 'invalid' }

  const phone = parsePhoneNumberFromString(candidate, { extract: false })
  return phone?.isValid() === true ? { normalized: phone.number } : { error: 'invalid' }
}
